<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/*body{*/
  /*background-image: url("./assets/img/bgc.png");*/
  /*background-color: #f8f8f8;*/
  /*background-repeat: no-repeat;*/
  /*/!*background-color: #fff;*!/*/
  /*/!*background-size: cover;*!/*/
  /*background-position-y: bottom;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/App.vue